export const entityKey = (item) => item?.documentId ?? item?.id ?? null;

export const sameEntity = (left, right) => {
    const leftKey = entityKey(left);
    const rightKey = entityKey(right);
    return leftKey !== null && rightKey !== null && String(leftKey) === String(rightKey);
};

export const categoryMeta = {
    mention: {label: "منشن‌ها", icon: "pi pi-at", color: "purple"},
    conversation: {label: "گفتگوها", icon: "pi pi-comments", color: "blue"},
    project: {label: "پروژه‌ها", icon: "pi pi-folder", color: "indigo"},
    goal: {label: "اهداف", icon: "pi pi-flag", color: "orange"},
    task: {label: "وظایف", icon: "pi pi-check-square", color: "green"},
    team: {label: "تیم", icon: "pi pi-users", color: "cyan"},
    access: {label: "دسترسی‌ها", icon: "pi pi-key", color: "pink"},
    report: {label: "گزارش‌ها", icon: "pi pi-chart-bar", color: "teal"},
    system: {label: "سایر", icon: "pi pi-bell", color: "gray"},
};

export const getCategoryMeta = (category) => categoryMeta[category] || categoryMeta.system;

export const isActivityItem = (item) => ["activity", "both"].includes(item?.eventSurface);

// «اعلان‌ها» is per workspace: an item belongs to the active workspace, or to none (account-level, e.g. security)
export const belongsToWorkspace = (item, workspace) => {
    const itemWorkspace = item?.workspace;
    if (!itemWorkspace) return true;
    const itemKeys = [itemWorkspace?.documentId, itemWorkspace?.id, typeof itemWorkspace !== "object" ? itemWorkspace : null]
        .filter((value) => value !== null && value !== undefined).map(String);
    const activeKeys = [workspace?.documentId, workspace?.id]
        .filter((value) => value !== null && value !== undefined).map(String);
    return itemKeys.some((key) => activeKeys.includes(key));
};

export const isIncomingItem = (item) => {
    if (["toast", "invisible", "app-update"].includes(item?.displayType)) return false;
    if (["inbox", "both"].includes(item?.eventSurface)) return true;
    return !item?.eventSurface;
};

export const getDateBucket = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "قدیمی‌تر";

    const today = new Date();
    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const dayDifference = Math.round((startOfToday - startOfDate) / 86400000);

    if (dayDifference === 0) return "امروز";
    if (dayDifference === 1) return "دیروز";
    return "قدیمی‌تر";
};

export const formatEventDate = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleString("fa-IR", {
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const includesSearch = (item, search) => {
    const needle = String(search || "").trim().toLocaleLowerCase("fa");
    if (!needle) return true;
    return [
        item?.title,
        item?.message,
        item?.sourceLabel,
        item?.contextLabel,
        item?.actor?.member?.fullname,
    ].some((value) => String(value || "").toLocaleLowerCase("fa").includes(needle));
};
